import React, { useContext } from "react"
import replace from "../../../utils/replace"
import getAvailability from "../../../utils/getAvailability"
import {
  longPriceForOffices,
  pricePerDesk,
  totalPriceForDesks,
} from "../../../utils/formattedPrices"
import isOnDemand from "../../../utils/isOnDemand"
import mapPrice from "../../../utils/mapPrice"
import { SpaceProfileContext } from "../context"
import isDd from "../../../utils/isDd"
import { CovidMessage } from "../InlineBookTour"

export default ({
  title,
  cmsPhone = null,
  image = false,
  retinaImage = false,
}) => {
  let phone = null
  let phoneStyled = null
  if (cmsPhone && cmsPhone.length > 0) {
    phone = cmsPhone[0].toBeLinked
    phoneStyled = cmsPhone[0].withStyles
  }

  const {
    actions: { setImageGalleryOpen, setImageGalleryIndex },
  } = useContext(SpaceProfileContext)

  return (
    <>
      <div className="container">
        <div className="space-profile-hero-section pt-0">
          <div className="row">
            <div className="col-md-12">
              <div className="space-location-title d-flex align-items-center">
                <h1>{replace(title)}</h1>
                {phoneStyled && phone && (
                  <a
                    href={`tel:${phone}`}
                    className={"space-phone-number ms-md-auto"}
                  >
                    {phoneStyled}
                  </a>
                )}
              </div>
            </div>

            {image && (
              <div className="col-sm-12">
                <div
                  className="hero-image clickable"
                  onClick={() => {
                    setImageGalleryOpen(true)
                    setImageGalleryIndex(0)
                  }}
                >
                  <img src={retinaImage || image} alt="" />
                  <span
                    onClick={() => {
                      setImageGalleryOpen(true)
                      setImageGalleryIndex(0)
                    }}
                  >
                    See All Photos
                  </span>
                </div>
              </div>
            )}

            <div className="col-sm-12 d-xl-none">
              <CovidMessage />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export const SummaryList = ({ className = "", displayPrice = false }) => {
  const {
    commonData: {
      isDaily,
      spaceSummary,
      filteredOptions,
      location,
      teamSize,
      closingTime,
    },
  } = useContext(SpaceProfileContext)

  const isDedicatedDesk = isDd(spaceSummary.space_type)

  const priceTerm = isOnDemand() ? "/day" : "/month"

  return (
    <div
      className={`workplace-one-space-summary ${className} ${
        isOnDemand() ? "on-demand" : ""
      }`}
    >
      <ul>
        <li>
          <span>Type</span>
          <span>{spaceSummary.space_type || "Private Offices"}</span>
        </li>
        <li>
          <span>Seat Count</span>
          <span>{teamSize}</span>
        </li>
        {isOnDemand() && isDaily && (
          <li>
            <span>Checkout time</span>
            <span>{closingTime}</span>
          </li>
        )}
        {!isOnDemand() && location && (
          <li>
            <span>Minimum Term</span>
            <span>
              {isDedicatedDesk
                ? location.dedicated_desks_term_commitment
                : location.office_term_commitment}
            </span>
          </li>
        )}
        {isDedicatedDesk ? (
          <>
            <li>
              <span>Price per desk</span>
              <span>
                {pricePerDesk(filteredOptions)}
                {priceTerm}
              </span>
            </li>
            <li>
              <span>Total price</span>
              <span>
                {totalPriceForDesks(filteredOptions, teamSize)}
                {priceTerm}
              </span>
            </li>
          </>
        ) : (
          <li>
            <span>Price</span>
            <span>
              {displayPrice
                ? `${longPriceForOffices(filteredOptions)}${priceTerm}`
                : "Contact for pricing"}
            </span>
          </li>
        )}
        {isOnDemand() && (
          <>
            {filteredOptions.length > 0 && (
              <li>
                <span>Price</span>
                <span>{`${mapPrice(filteredOptions, isDaily)}/${
                  isDaily ? "day" : "hour"
                }`}</span>
              </li>
            )}
          </>
        )}
        {!isOnDemand() && (
          <li>
            <span>Availability</span>
            <span>{getAvailability(filteredOptions)}</span>
          </li>
        )}
        {!isOnDemand() && !isDedicatedDesk && filteredOptions.length > 0 && (
          <li>
            <span>No. Options</span>
            <span>{filteredOptions.length >= 2 ? 2 : 1}</span>
          </li>
        )}
      </ul>
    </div>
  )
}
